// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 9473 ? "trade" : chunkId) + "." + {"6967":"89798e90","6969":"7ebe436c","7582":"82df4d69","9473":"9b073633"}[chunkId] + ".css";
};